<template>
  <div>
    <ClearPhoneNoDialog :type-fix="clearPhoneNumDialog.typeForFixButton" :show="clearPhoneNumDialog.isShow"
                        :pageName="clearPhoneNumDialog.pageName" @dialogClose="clearDialogClose"></ClearPhoneNoDialog>

    <RecordShowDetailDrawer drawer-title="访客记录详情" :area-map="areaMap" ref="recordDetailDrawer"
                            :phoneNumShow="phoneNumShow"></RecordShowDetailDrawer>

    <div class="manage-table">

      <div class="search-box">
        <el-form label-width="70px " :model="formSearch" size="mini" class="demo-form-inline" label-position="left">
          <el-form-item label="访客姓名">
            <el-input v-model="formSearch.visitorName" placeholder="请输入访客姓名" clearable></el-input>
          </el-form-item>

          <el-form-item label="日期范围">
            <el-date-picker
                class="my-date-picker"
                v-model="formSearch.dateArea"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="签离区域">
            <el-select v-model="formSearch.leaveArea" :placeholder="`请选择签离区域`" style="width: calc(100% - 50px) "
                       :popper-append-to-body="false" value-key="id" clearable>
              <el-option :value="formSearch.leaveSelectTree" class="setstyle" style="overflow: auto; height: 100%"
                         disabled
                         :key="formSearch.leaveSelectTree.id" :label="formSearch.leaveSelectTree.name">
                <el-tree style="min-height: 150px; max-height: 300px" :data="areaTree" :props="areaProps"
                         ref="tree"
                         check-strictly :expand-on-click-node="false"
                         @node-click="(data, node, item) => areaNodeLeaveClick(data, node, item)"></el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="访客卡号">
            <el-input v-model="formSearch.visitorCardNo" placeholder="请输入访客卡号" clearable></el-input>
          </el-form-item>
        </el-form>


        <el-form label-width="70px " :model="formSearch" size="mini" class="demo-form-inline" label-position="left">
          <el-form-item label="访客手机">
            <el-input v-model="formSearch.visitorPhoneNo" placeholder="请输入访客手机" clearable></el-input>
          </el-form-item>

          <el-form-item label="时间范围">
            <el-time-picker style="margin-right: 10px"
                            class="my-time-select"
                            placeholder="起始时间"
                            value-format="HH:mm"
                            format="HH:mm"
                            v-model="formSearch.startTime"
                            :picker-options="pickerOptions">
            </el-time-picker>
            <el-time-picker
                class="my-time-select"
                placeholder="结束时间"
                v-model="formSearch.endTime"
                value-format="HH:mm"
                format="HH:mm"
                :picker-options="pickerOptions">
            </el-time-picker>
          </el-form-item>

          <el-form-item label="员工部门" class="inner-form-item">
            <el-select v-model="formSearch.department" :placeholder="`请选择部门`"
                       :popper-append-to-body="false" value-key="id" clearable>
              <el-option :value="selectTree" class="setstyle" style="overflow: auto; height: 100%" disabled
                         :key="selectTree.id" :label="selectTree.name">
                <el-tree style="min-height: 150px; max-height: 300px" :data="customerList" :props="defaultProps"
                         ref="tree"
                         check-strictly :expand-on-click-node="false"
                         @node-click="(data, node, item) => addAdminHandleNodeClick(data, node, item)"></el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <div class="button-area">
            <span>
                 <el-button type="primary" @click="onSearchClick" size="mini">查询</el-button>
                <el-button type="success" plain @click="onResetSearch" size="mini">重置</el-button>
            </span>
            <span>
            <el-button type="danger" plain size="mini" style="margin-left: 50px" @click="cleartextShow('访客记录')">
              明文查看
            </el-button>

            <el-button type="warning" plain size="mini" @click="exportData"> 数据导出</el-button>
            </span>
          </div>
        </el-form>

        <el-form label-width="70px " :model="formSearch" size="mini" class="demo-form-inline" label-position="left">
          <el-form-item label="到访情况">
            <el-select class="my-select" v-model="formSearch.visitStatus" size="mini" clearable>
              <el-option v-for="item in searchArea.visitStatus" :key="item.value" :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签到区域">
            <el-select v-model="formSearch.enterArea" :placeholder="`请选择签到区域`"
                       :popper-append-to-body="false" value-key="id" clearable>
              <el-option :value="formSearch.enterSelectTree" class="setstyle" style="overflow: auto; height: 100%"
                         disabled
                         :key="formSearch.enterSelectTree.id" :label="formSearch.enterSelectTree.name">
                <el-tree style="min-height: 150px; max-height: 300px" :data="areaTree" :props="areaProps"
                         ref="tree"
                         check-strictly :expand-on-click-node="false"
                         @node-click="(data, node, item) => areaNodeEnterClick(data, node, item)"></el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车牌号码">
            <el-input v-model="formSearch.visitorCarNo" placeholder="请输入访客车牌号码" clearable
                      style="width: 100%"></el-input>
          </el-form-item>

        </el-form>
      </div>

      <el-table stripe border class="right-desc" :data="tableData" size="mini">
        <el-table-column v-for="(headerItem) in mainTableHeader" :key="headerItem.prop" :prop="headerItem.prop"
                         :label="headerItem.label">
          <template slot-scope="scope">
            <template v-if="headerItem.type === 0">{{ scope.row[headerItem.prop] }}</template>
            <template v-else-if="headerItem.type === 1">{{
                scope.row[headerItem.prop] | tableDateFilter(headerItem.prop)
              }}
            </template>
            <template v-else-if="headerItem.type === 9">
              <template v-if="phoneNumShow">
                {{ scope.row[headerItem.prop] }}
              </template>
              <template v-else>
                {{ scope.row[headerItem.prop] | phNoFilter }}
              </template>
            </template>
            <el-tag v-else-if="headerItem.type === 2">{{
                scope.row[headerItem.prop] | tableDateFilter(headerItem.prop)
              }}
            </el-tag>
            <template v-else-if="headerItem.type > 100">
              <el-button v-if="(headerItem.type % 100) & 1" type="primary" size="mini"
                         @click="tableShow(scope.row)">查看
              </el-button>
              <el-button v-if="(headerItem.type % 100) & 2" type="warning" size="mini"
                         @click="tableEdit(scope.row)">编辑
              </el-button>
              <el-button v-if="(headerItem.type % 100) & 4" type="danger" size="mini"
                         @click="tableDelete(scope.row)">删除
              </el-button>
            </template>
            <template v-else> {{ scope.row[headerItem.prop] }}</template>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination layout="sizes, prev, pager, next, jumper" :total="totalCount" :page-sizes="pageSizes"
                       :page-size.sync="curPageSize" :pager-count="5"
                       :current-page.sync="curPageIndex" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import {mixin_clearPhoneNumShow, mixin_page_table} from '@/utils/mixin'
import {getRecordList} from '@/api/record-api'
import ClearPhoneNoDialog from "@/components/ClearPhoneNoDialog.vue";
import {getFileUrl} from "@/utils/fileUploadUtils";
import {export_mixin} from "@/pages/visitRecord/export_mixin";
import {getFormData} from "@/api/apply-api";
import {getAllArea} from "@/api/device-manager-api";
import RecordShowDetailDrawer from "@/components/RecordShowDetailDrawer.vue";
import {getAllDepartment} from "@/api/organize-api";
import {getSettingItem} from "@/api/setting-api";
import ExcelJS from "exceljs";

export default {
  components: {RecordShowDetailDrawer, ClearPhoneNoDialog},
  mixins: [mixin_page_table, mixin_clearPhoneNumShow, export_mixin],

  data() {
    return {
      icHidden: false,

      // type 定义：
      // 0，数据不需要处理
      // 1，数据需要过滤，使用 tableDateFilter
      // 2. 数据需要加标签并过滤，使用 tableDateFilter
      // 100. 添加 button ，规则：对100 取余，
      //          结果二进制第1位代表 查看 button， 点击调用 tableShow
      //          结果二进制第2位代表 编辑 button， 点击调用 tableEdit
      //          结果二进制第3位代表 删除 button， 点击调用 tableDelete
      mainTableHeader: [],
      pickerOptions: {
        selectableRange: '00:00:00-23:59:59', // 设置可选的时间范围
        format: 'HH:mm' // 设置时间显示格式
      },
      formSearch: {
        visitorName: "",
        visitorPhoneNo: "",
        visitStatus: "",
        dateArea: [],
        startTime: "",
        endTime: "",
        enterArea: "",
        leaveArea: "",
        enterAreaId: "",
        leaveAreaId: "",
        enterSelectTree: "",
        leaveSelectTree: "",
        department: "",
        selectDepartment: "",
        visitorCarNo: "",
        visitorCardNo: "",

      },
      departmentMap: {},
      defaultProps: {
        children: "departments",
        label: "name",
      },
      customerList: [],
      selectTree: "",

      searchEnsureParam: {},

      searchArea: {
        visitStatus: [
          {value: "", label: "已签到"},
          {value: "ENTER", label: "未签离"},
          {value: "LEAVE", label: "已签离"},
        ]
      },

      // drawer start

      areaTree: [],
      areaMap: {},
      areaProps: {
        children: "areas",
        label: "name",
      },

      areaConfig: {
        areaLimit: false,
        areaIdList: [],
      }
    }

  },
  mounted() {
    // 身份证字段显隐（预约+邀约任一配置为不展示则全端隐藏）
    Promise.all([
      getSettingItem("VISITORINFO", "VISITOR_BOOK"),
      getSettingItem("VISITORINFO", "VISITOR_INVITE"),
    ]).then(([bookRes, inviteRes]) => {
      const readHidden = (res) => {
        if (res.data.code === 200 && res.data.data && res.data.data.length > 0) {
          try {
            const content = JSON.parse(res.data.data[0].content || "{}")
            return content && content.idCardNo === 1
          } catch (e) {
            return false
          }
        }
        return false
      }
      this.icHidden = readHidden(bookRes) || readHidden(inviteRes)
    }).catch(err => {
      console.log("load visitor field setting err", err)
    })
    this.doGetAllArea()
    getAllDepartment().then(({data}) => {
      console.log("getAllDepartment result =>", data)
      this.customerList = data.data
      if (data.code === 200) {
        this.saveEmployeeToMap(data.data)
      }
    }).catch(err => {
      console.log("getAllDepartment err =>", err)
      this.showNetErrMsg();
    })
  },

  methods: {
    saveEmployeeToMap(employeeList) {
      employeeList.forEach(item => {
        this.departmentMap[item.id] = item
        if (item.departments && item.departments.length > 0) {
          this.saveEmployeeToMap(item.departments)
        }
      })
    },
    doGetAllArea() {
      getAllArea().then(({data}) => {
        if (data.code === 200) {
          this.areaTree = data.data
          this.areaMap = {}
          this.areaTree.forEach(item => {
            this.areaMap[item.id] = item
            ;(item.areas || []).forEach(subItem => {
              this.areaMap[subItem.id] = subItem
            })
          })
        } else {
          this.showServerErrMsg(data.msg)
        }
        if (this.$store.state.roleType === "COMMON") {
          this.areaConfig = {
            areaLimit: true,
            areaIdList: [],
          }
          let myAreaIds = this.visitType === "subscribe" ? this.$store.state.myApplyAreaIds : this.$store.state.myArriveAreaIds
          myAreaIds.forEach(item => {
            let area = this.areaMap[item]
            this.areaConfig.areaIdList.push(area.id)
            ;(area.areas || []).forEach(subArrea => {
              this.areaConfig.areaIdList.push(subArrea.id)
            })
          })

          let myAreaList = []
          data.data.forEach(area => {
            let find = this.areaConfig.areaIdList.find(item => item === area.id)
            if (find) {
              myAreaList.push(area)
            }
          })
          this.areaTree = myAreaList
        } else {
          this.areaConfig = {
            areaLimit: false,
            areaIdList: [],
          }
        }
        this.searchEnsureParam = this.getSearchParams()

        this.initTableStruct()
        this.refreshTableData()
      }).catch(err => {
        console.log("doGetAllArea err", err)
        this.showNetErrMsg()

        this.initTableStruct()
        this.refreshTableData()
      })

    },
    areaNodeEnterClick(e) {
      this.formSearch.enterArea = e.name;
      this.formSearch.enterSelectTree = e;
    },

    areaNodeLeaveClick(e) {
      this.formSearch.leaveArea = e.name;
      this.formSearch.leaveSelectTree = e;
    },

    initTableStruct() {
      this.mainTableHeader = [
        {prop: 'param4', label: '访客姓名', type: 0},
        {prop: 'param5', label: '访客手机', type: 9},
        {prop: 'param10', label: '到访时间', type: 0},
        {prop: 'param11', label: '离开时间', type: 0},
        {prop: 'param15', label: '签到区域', type: 0},
        {prop: 'param16', label: '签到子区域', type: 0},
        {prop: 'param17', label: '访客编码', type: 0},
        {prop: 'param13', label: '是否到访', type: 2},
        {prop: 'param14', label: '操作', type: 101},
      ]
    },

    refreshTableData() {
      this.tableData = []
      const postData = {
        recordType: "UNIVERSAL", // recordType：取值位UNIVERSAL, USUAL。分别表示正常的访客和常访类型的访客。
        current: this.curPageIndex,
        size: this.curPageSize,
      }
      let topDeptIds = this.$store.state.myArriveDepartmentIds
      if (topDeptIds && topDeptIds.length > 0) {
        postData.topDeptIds = topDeptIds
      }

      const searchParam = Object.assign(postData, this.searchEnsureParam)
      console.log("searchParam", searchParam)
      getRecordList(searchParam).then(({data}) => {
        console.log("getRecordList get data ", data);
        if (data.code !== 200) {
          this.showServerErrMsg(data.code)
          return
        }

        if (data.data == null) {
          return
        }
        this.totalCount = data.data.totals

        data.data.data.forEach(item => {

          let enterShowTime = ""
          if (item.enterDate && item.enterTime) {
            enterShowTime = `${item.enterDate} ${item.enterTime.substr(0, 5)}`
          }
          let leaveShowTime = ""
          if (item.leaveDate && item.leaveTime) {
            leaveShowTime = `${item.leaveDate} ${item.leaveTime.substr(0, 5)}`
          }
          let area = this.areaMap[item.enterAreaId]
          let areaName = ""
          let superAreaName = ""
          if (area) {
            if (area.parentId > 0) {
              let superArea = this.areaMap[area.parentId]
              if (superArea) {
                superAreaName = superArea.name
              }
              areaName = area.name
            } else {
              superAreaName = area.name
            }
          }

          this.tableData.push({
            data: item,
            param4: item.visitor ? item.visitor.name : "",
            param5: item.visitor ? item.visitor.tel : "",
            param10: enterShowTime,
            param11: leaveShowTime,
            param15: superAreaName,
            param16: areaName,
            param17: item.enterCardNo || "",
            param13: item.completeState,
          })
        });

      }).catch(() => {
        this.showNetErrMsg()
      })
    },
    addAdminHandleNodeClick(e) {
      console.log(e);
      this.formSearch.department = e.name;
      this.formSearch.selectDepartment = e;
    },


    tableShow(rowData) {
      this.$refs.recordDetailDrawer.showRecordDetail(rowData.data)
    },

    onSearchClick() {
      this.searchEnsureParam = this.getSearchParams()
      this.curPageIndex = 1
      this.refreshTableData()
    },
    onResetSearch() {
      this.formSearch = {
        visitorName: "",
        visitorPhoneNo: "",
        visitStatus: "",
        dateArea: [],
        startTime: "",
        endTime: "",
        enterArea: "",
        leaveArea: "",
        enterAreaId: "",
        leaveAreaId: "",
        enterSelectTree: "",
        leaveSelectTree: "",
        department: "",
        selectDepartment: "",
        visitorCardNo: "",
        visitorCarNo: "",
      }
      this.searchEnsureParam = {}
      this.curPageIndex = 0
      this.refreshTableData()
    },

    checkExportDatePass() {
      if (this.formSearch.dateArea.length === 0) {
        this.$message.error("请选择日期范围")
        return false
      }
      // 日期不能超过一年
      let startDate = new Date(this.formSearch.dateArea[0])
      let endDate = new Date(this.formSearch.dateArea[1])
      let diff = endDate - startDate
      if (diff > 366 * 24 * 3600 * 1000) {
        this.$message.error("日期范围不能超过一年")
        return false
      }

      return true

    },

    async exportData() {
      if (!this.checkFixButtonPass()) {
        return
      }
      if (!this.checkExportDatePass()) {
        return
      }

      let formsResponse1 = await getFormData("BOOK_APPLY")
      if (formsResponse1.data.code !== 200) {
        this.showServerErrMsg(formsResponse1.data.msg)
        return
      }
      let formList1 = formsResponse1.data.data.formItems

      let formsResponse2 = await getFormData("INVITE_APPLY")
      if (formsResponse2.data.code !== 200) {
        this.showServerErrMsg(formsResponse2.data.msg)
        return
      }
      let formList2 = formsResponse2.data.data.formItems
      let formList = []
      formList.push(...formList1)
      formList2.forEach(item => {
        let find = formList1.find(item1 => item1.name === item.name)
        if (!find) {
          formList.push(item)
        }
      })

      let formNameList = []
      formNameList.push({title: "对接员工", valueGetter: (item) => item.employee ? item.employee.name : ""})
      formNameList.push({title: "员工部门", valueGetter: (item) => item.employee ? item.employee.departmentName : ""})
      formNameList.push({title: "员工手机", valueGetter: (item) => item.employee ? item.employee.tel : ""},)
      formNameList.push({title: "员工邮箱", valueGetter: (item) => item.employee ? item.employee.email : ""},)

      formNameList.push({title: "访客姓名", valueGetter: (item) => item.visitor.name})
      formNameList.push({title: "访客国籍", valueGetter: (item) => item.visitor.nationality})
      formNameList.push({title: "访客手机", valueGetter: (item) => item.visitor.tel})
      if (!this.icHidden) {
        formNameList.push({title: "访客证件", valueGetter: (item) => item.visitor.ic})
      }
      formNameList.push({title: "访客邮箱", valueGetter: (item) => item.visitor.email})
      formNameList.push({title: "访客地址", valueGetter: (item) => item.visitor.address})
      formNameList.push({title: "访客单位", valueGetter: (item) => item.visitor.company})

      formNameList.push({
        title: "签到区域", valueGetter: (item) => {
          let area = this.areaMap[item.enterAreaId]
          if (area) {
            let supArea = this.areaMap[area.parentId]
            if (supArea) {
              return supArea.name
            } else {
              return area.name
            }
          }
          return ""
        }
      })

      formNameList.push({
        title: "签到子区域", valueGetter: (item) => {
          let area = this.areaMap[item.enterAreaId]
          if (area) {
            let supArea = this.areaMap[area.parentId]
            if (supArea) {
              return area.name
            } else {
              return ""
            }
          }
          return ""
        }
      })
      formNameList.push({title: "签到保安", valueGetter: (item) => item.enterGuardName})
      formNameList.push({title: "访客编码", valueGetter: (item) => item.enterCardNo || ""})

      formNameList.push({
        title: "签离区域", valueGetter: (item) => {
          let area = this.areaMap[item.leaveAreaId]
          if (area) {
            let supArea = this.areaMap[area.parentId]
            if (supArea) {
              return supArea.name
            } else {
              return area.name
            }
          }
          return ""
        }
      })

      formNameList.push({
        title: "签离子区域", valueGetter: (item) => {
          let area = this.areaMap[item.leaveAreaId]
          if (area) {
            let supArea = this.areaMap[area.parentId]
            if (supArea) {
              return area.name
            } else {
              return ""
            }
          }
          return ""
        }
      })
      formNameList.push({title: "签离保安", valueGetter: (item) => item.leaveGuardName})
      formList.forEach(formItem => {
        formNameList.push({
          title: formItem.title, valueGetter: (item) => {
            if (item.apply.forms == null) {
              return ""
            }
            if (formItem.name === "startTime") {
              return `${item.apply.beginDate} ${item.apply.beginTime.substr(0, 5)}`
            }
            if (formItem.name === "endTime") {
              return `${item.apply.endDate} ${item.apply.endTime.substr(0, 5)}`
            }
            let find = item.apply.forms.find(form => form.name === formItem.name)
            return find ? find.value : ""
          }
        })
      })

      formNameList.push({
        title: "到访时间",
        valueGetter: (item) => item.enterDate && item.enterTime ? `${item.enterDate} ${item.enterTime.substr(0, 5)}` : ""
      })
      formNameList.push({
        title: "离开时间",
        valueGetter: (item) => item.leaveDate && item.leaveTime ? `${item.leaveDate} ${item.leaveTime.substr(0, 5)}` : ""
      })
      formNameList.push({
        title: "是否到访", valueGetter: (item) => {
          return this.$options.filters.tableDateFilter(item.completeState, 'param13')
        }
      })
      formNameList.push({
        title: "证件照片", valueGetter: (item) => {
          return item.visitor.certPhoto ? getFileUrl(item.visitor.certPhoto) : ""
        }
      })

      formNameList.push({
        title: "签到照片", valueGetter: (item) => {
          return item.enterPhoto ? getFileUrl(item.enterPhoto) : ""
        }
      })


      await this.doExportRecord(formNameList)
    },

    getAllSelectDepartmentIds(selectDepartment, saveArr) {
      saveArr.push(selectDepartment.id)
      if (selectDepartment.departments && selectDepartment.departments.length > 0) {
        for (let i = 0; i < selectDepartment.departments.length; i++) {
          this.getAllSelectDepartmentIds(selectDepartment.departments[i], saveArr)
        }
      }
    },

    getSearchParams() {
      let params = {}
      if (this.formSearch.visitorName) {
        params.visitorName = this.formSearch.visitorName
      }
      if (this.formSearch.visitorPhoneNo) {
        params.visitorTel = this.formSearch.visitorPhoneNo
      }

      if (this.formSearch.visitStatus && this.formSearch.visitStatus !== "ALL") {
        params.arrived = this.formSearch.visitStatus
      }
      if (this.formSearch.dateArea.length > 1) {
        params.beginDate = this.formSearch.dateArea[0]
        params.endDate = this.formSearch.dateArea[1]
      }
      if (this.formSearch.startTime || this.formSearch.endTime) {
        params.beginTime = this.formSearch.startTime ? this.formSearch.startTime + ":00" : "00:00:00"
        params.endTime = this.formSearch.endTime ? this.formSearch.endTime + ":59" : "23:59:59"
      }
      if (this.formSearch.enterArea && this.formSearch.enterSelectTree) {
        if (this.formSearch.enterSelectTree.parentId === -1) {
          params.enterAreaIds = (this.formSearch.enterSelectTree.areas || []).map(item => item.id)
        } else {
          params.enterAreaIds = [this.formSearch.enterSelectTree.id]
        }
      } else {
        if (this.areaConfig.areaLimit) {
          params.enterAreaIds = this.areaConfig.areaIdList
        }
      }
      if (this.formSearch.leaveArea && this.formSearch.leaveSelectTree) {
        if (this.formSearch.leaveSelectTree.parentId === -1) {
          params.leaveAreaIds = (this.formSearch.leaveSelectTree.areas || []).map(item => item.id)
        } else {
          params.leaveAreaIds = [this.formSearch.leaveSelectTree.id]
        }
      } else {
        // if (this.areaConfig.areaLimit) {
        //   params.leaveAreaIds = this.areaConfig.areaIdList
        // }
      }
      if (this.formSearch.department && this.formSearch.selectDepartment) {
        params.departmentIds = []
        this.getAllSelectDepartmentIds(this.formSearch.selectDepartment, params.departmentIds)
      }

      if (this.formSearch.visitorCarNo) {
        params.enterCarNum = this.formSearch.visitorCarNo
      }
      if (this.formSearch.visitorCardNo) {
        params.enterCardNo = this.formSearch.visitorCardNo
      }

      return params
    },

    async doExportRecord(formNameList) {
      console.log("doExportRecord", formNameList)
      const columnsSize = formNameList.length
      const workbook = new ExcelJS.Workbook()
      const sheet = workbook.addWorksheet('Sheet1');
      let headerList = this.getHeader(formNameList)
      sheet.addRow(headerList)
      const firstRow = sheet.getRow(1);
      firstRow.eachCell((cell, colNumber) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {argb: 'FFD9D9D9'},
          bgColor: {argb: 'FFD9D9D9'}
        };
        cell.font = {
          size: 12,
          bold: true
        };
      });
      firstRow.height = 20;
      for (let i = 0; i < columnsSize; i++) {
        sheet.getColumn(i + 1).width = 12;
      }


      const postData = {
        recordType: "UNIVERSAL",
        current: 1,
        size: 100,
      }
      let searchEnsureParam = this.getSearchParams()
      const searchParam = Object.assign(postData, searchEnsureParam)

      let pageMax = 10000

      while (searchParam.current <= pageMax) {
        try {
          console.log("download getApproveList start " + searchParam)
          let result = await getRecordList(searchParam);
          pageMax = result.data.data.pages

          console.log("download getApproveList result ", result)

          if (result.data.code !== 200 || !result.data.data || !result.data.data.data || result.data.data.data.length === 0) {
            // 如果结果不符合条件，写入Excel文件并退出
            break;
          }

          // 处理数据
          result.data.data.data.forEach(item => {
            if (item.visitor == null) {
              // 跳过脏数据
              return
            }
            let rowData = this.getRowData(formNameList, item);
            sheet.addRow(rowData);
          });

          // 更新搜索参数并继续获取数据
          searchParam.current++;
          console.log("download getApproveList start " + searchParam.current)
        } catch (err) {
          searchParam.current++;
        }
      }
      await this.finalDownload2(workbook, "到访记录");
    },

  },
  filters: {
    tableDateFilter(value, prop) {
      if (prop === "param12") {
        switch (value) {
          case 'PROCESS':
            return "审批中"
          case 'PASS':
            return '已通过'
          case 'REJECT':
            return '已拒绝'
          case 'CANCEL':
            return '已撤销'
          case 'NONE':
            return '审批中'
          default:
            return value
        }
      } else if (prop === "param13") {
        switch (value) {
          case 'NO':
            return "未到访"
          case 'ENTER':
            return '已到访'
          case 'LEAVE':
            return '已离开'
          default:
            return value
        }
      } else {
        return value
      }
    },

  }

}
</script>

<style lang="less" scoped>

.search-box {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: start;

  .demo-form-inline {
    width: 33%;

    .el-input {
      width: calc(100% - 50px);
    }

    .el-select {
      width: calc(100%);
    }

    .inner-form-item {

      .el-select {
        width: calc(100% - 50px);
      }
    }


    .my-date-picker {
      width: calc(100% - 50px);
    }

    .my-time-select {
      width: calc(50% - 30px);
    }

    .button-area {
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
      margin-top: 10px;

    }

    //background-color: red;
  }
}

.manage-table {
  height: calc(100vh - 120px);

}

.right-desc {
  max-height: calc(100vh - 260px);
  overflow-y: auto;
}

/deep/ .el-form-item--mini.el-form-item {
  margin-bottom: 10px;
}

.my-date-picker /deep/ .el-range-separator {
  min-width: 22px;
}
</style>
